import _ from 'underscore';
import { STEP_PATHS } from './step-paths';

export const WIZARD_ACTIONS = {
  WIZARD_NAVIGATE_TO_STEP: 'WIZARD_NAVIGATE_TO_STEP',
  WIZARD_NAVIGATE_BACK: 'WIZARD_NAVIGATE_BACK',
  WIZARD_NAVIGATE_NEXT: 'WIZARD_NAVIGATE_NEXT',
  WIZARD_SET_LAST_STEP_AND_NAVIGATE_NEXT: 'WIZARD_SET_LAST_STEP_AND_NAVIGATE_NEXT',
  // GTM session context
  WIZARD_UPDATE_GTM_SESSION_CONTEXT: 'WIZARD_UPDATE_GTM_SESSION_CONTEXT',
};

function navigateToStepIndex(state, index) {
  let stepIndexCurrent = index;
  const stepIndexMax = state.steps.length - 1;
  if (stepIndexCurrent < 0 || stepIndexCurrent > stepIndexMax) {
    // if step does not exist or is not permitted, take the user to stepIndexMax
    stepIndexCurrent = stepIndexMax;
  }

  return {
    ...state,
    stepIndexCurrent,
  };
}

const basicSteps = [
  STEP_PATHS.info,
  STEP_PATHS.specialPages,
  STEP_PATHS.editWebsite.pickEdit,
];

export const getWizardDefaultState = () => ({
  stepIndexCurrent: 0,
  steps: basicSteps,
  GTMContext: {
    IsGTMCloningChecked: true,
    AllowTagCloning: true,
  },
});

export function conversionWizardReducer(state, action) {
  switch (action.type) {
    case (WIZARD_ACTIONS.WIZARD_NAVIGATE_TO_STEP):
      return navigateToStepIndex(
        state,
        _.findIndex(state.steps, action.step)
      );
    case (WIZARD_ACTIONS.WIZARD_NAVIGATE_BACK):
      return navigateToStepIndex(state, state.stepIndexCurrent - 1);
    case (WIZARD_ACTIONS.WIZARD_NAVIGATE_NEXT):
      return navigateToStepIndex(state, state.stepIndexCurrent + 1);
    case (WIZARD_ACTIONS.WIZARD_SET_LAST_STEP_AND_NAVIGATE_NEXT): {
      // Choose next step based on state.
      // By default, use the tag[editSubstep] - this covers most cases.
      // But, if the substep is third party tag and no platform is selected, show the pickPlatform step.
      let nextStep = STEP_PATHS.tag[action.editSubstep];

      if (action.editSubstep === 'thirdPartyTag' && !action.selectedPlatform) {
        nextStep = STEP_PATHS.editWebsite.pickPlatform;
      }

      // Because there are multiple options for adding steps, the state cannot be easily recreated from basicSteps.
      // Instead, trim state-based steps back to the current step, then add the next one.
      const oldSteps = [...state.steps];

      oldSteps.length = state.stepIndexCurrent + 1;

      const updatedState = {
        ...state,
        steps: [...oldSteps, nextStep],
        selectedPlatform: action.selectedPlatform,
      };
      return navigateToStepIndex(updatedState, state.stepIndexCurrent + 1);
    }
    case (WIZARD_ACTIONS.WIZARD_UPDATE_GTM_SESSION_CONTEXT):
      return {
        ...state,
        GTMContext: { ...action.GTMContext },
      };

    default: throw new Error(`Invalid conversion wizard action: ${action.type}`);
  }
}
